/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_MediumInputs */

const en_fit_medium = /** @type {(inputs: Fit_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average fit`)
};

const de_fit_medium = /** @type {(inputs: Fit_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittlere Passung`)
};

/**
* | output |
* | --- |
* | "Average fit" |
*
* @param {Fit_MediumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fit_medium = /** @type {((inputs?: Fit_MediumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_MediumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fit_medium(inputs)
	return en_fit_medium(inputs)
});